module.exports = __webpack_public_path__ + "static/media/pain-overview-large.4072017b.png";